<template>
    <div class="section-container flex flex-col items-center lg:flex-row lg:items-start space-y-5 lg:space-y-0 lg:space-x-12 lg:justify-center xl:space-x-24">
        <div class="access lg:w-1/2">
            <div class="header">
                <div class="icon-container">
                    <img src="/img/icons/key-white.svg">
                </div>
                <div class="title-container" @click="toggle">
                    <h4>{{ $trans.get('courses-show.access') }}</h4>
                    <img class="dropdown-arrow" :class="{ 'rotated': isExpanded }" src="/img/icons/arrow-down.svg">
                </div>
            </div>
            <div class="content">
                <ul>
                    <li v-for="prospect in prospects" :key="prospect.id">
                        {{ prospect.name[locale] }}
                    </li>
                </ul>
            </div>
        </div>

        <div class="marketability lg:w-1/2">
            <div class="header">
                <div class="icon-container">
                    <img src="/img/icons/job-white.svg">
                </div>
                <div class="title-container" @click="toggle">
                    <h4>{{ $trans.get('courses-show.opportunities') }}</h4>
                    <img class="dropdown-arrow" :class="{ 'rotated': isExpanded }" src="/img/icons/arrow-down.svg">
                </div>
            </div>
            <div class="content">
                <ul>
                    <li v-for="opportunity in opportunities" :key="opportunity.id">
                        {{ opportunity.name[locale] }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { toggleCollapsible } from '../../utils/collapsible';

export default {
    props: {
        prospects: {
            type: Array,
            default: () => []
        },
        opportunities: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            locale: window.appLocale,
            isExpanded: false
        }
    },
    mounted() {
        const arrows = document.querySelectorAll('.dropdown-arrow');
        console.log('Arrows:', arrows);
    },

    methods: {
        toggle(e) {
            toggleCollapsible(e.currentTarget.closest('.header').nextElementSibling);
            e.currentTarget.querySelector('.dropdown-arrow').classList.toggle('rotated');
        }
    },
}
</script>
